import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import useSWR from 'swr';
import SpinLoading from './components/loading/SpinLoading';

/** Region subtag of navigator.language, e.g. 'vi-VN' → 'VN'. */
function browserRegionGuess(): string | null {
    if (typeof navigator === 'undefined') return null;
    const m = /-([A-Za-z]{2})$/.exec(navigator.language ?? '');
    return m ? m[1].toUpperCase() : null;
}

export function RegionBlocked({ children }: PropsWithChildren) {
    const { t } = useTranslation();
    const { data, isLoading } = useSWR(
        'https://pricefeed.holdstation.com/location',
        async (url) => {
            const res = await fetch(url);
            if (!res.ok) {
                throw new Error('Failed to check region');
            }

            const { country } = await res.json();
            const localBrowser = browserRegionGuess();

            return { blocked: country === 'TH' || localBrowser === 'TH' };
        }
    );

    if (isLoading) {
        return (
            <div className="flex items-center justify-center h-dvh w-dvw">
                <SpinLoading className="w-5 h-5" />
            </div>
        );
    }

    if (data?.blocked) {
        return (
            <div className="flex items-center justify-center h-dvh w-dvw flex-col ">
                <img src="/images/map_close.png" className="w-12 h-12" />
                <p className="text-center mt-3 text-black text-2xl font-medium">
                    {t('Region Not Supported')}
                </p>
                <p className="mt-1 text-center text-[#666] text-sm font-medium">
                    {t('This region is not supported')}
                </p>
            </div>
        );
    }

    return children;
}
